import React from 'react';
import classnames from 'classnames';
import ArrowRightIcon from '@wix/da-shared-react/pkg/Icons/ArrowRight';
import ArrowLeftIcon from '@wix/da-shared-react/pkg/Icons/ArrowLeft';
import ArrowDownIcon from '@wix/da-shared-react/pkg/Icons/ArrowDown';
import ArrowUpIcon from '@wix/da-shared-react/pkg/Icons/ArrowUp';
import ProfileStatItems from '@wix/da-shared-react/pkg/ProfileStatItems';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import { withTranslation, WithTranslation } from 'react-i18next';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import BiDiv from '@wix/da-bi/pkg/Components/BiDiv';

import s from './ProfileStats.scss';

export interface Props {
  isMobile?: boolean;
}

export interface State {
  isExpanded: boolean;
}

class ProfileStats extends React.Component<Props & WithTranslation, State> {
  state = {
    isExpanded: false,
  };

  toggleExpanded = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  render() {
    const { isMobile } = this.props;
    const { isExpanded } = this.state;
    const defaultStats = isMobile
      ? ['watchers', 'deviations']
      : ['watchers', 'pageviews', 'deviations'];
    const additionalStats = !isExpanded
      ? []
      : isMobile
      ? ['pageviews', 'commentsMade', 'favourites']
      : ['commentsMade', 'favourites'];
    const { t, children, ...restProps } = this.props;

    let ExpandedIcon;
    let CollapsedIcon;

    if (isMobile) {
      ExpandedIcon = ArrowUpIcon;
      CollapsedIcon = ArrowDownIcon;
    } else {
      ExpandedIcon = ArrowLeftIcon;
      CollapsedIcon = ArrowRightIcon;
    }

    return (
      <BiDiv
        className={classnames(s['root'], isExpanded && s['expanded'])}
        onClick={isMobile ? this.toggleExpanded : undefined}
        biData={{
          evid: BiEventType.PROFILE_SUB_NAV_BAR_TOGGLE,
          toggle_value: isExpanded ? 'close' : 'open',
        }}
      >
        <ProfileStatItems
          statsData={restProps as any}
          defaultStats={defaultStats}
          additionalStats={additionalStats}
          itemClassName={s['stats-item']}
        />
        <span
          className={s['arrow']}
          onClick={!isMobile ? this.toggleExpanded : undefined}
        >
          {isExpanded ? (
            <ExpandedIcon size={IconSize.SMALL} />
          ) : (
            <CollapsedIcon size={IconSize.SMALL} />
          )}
        </span>
      </BiDiv>
    );
  }
}

export default withMobileContext(withTranslation()(ProfileStats));
